/**
 * company.ts - Centralized legal/business identity.
 *
 * Privacy Policy, Terms of Service, and the footer all read from this one
 * module so entity name, contact, governing-law state, and mailing address
 * only need to change in one place. To reuse this site's legal pages on a
 * different property, edit COMPANY (and PROCESSORS in privacy content) —
 * the rest of the legal-page structure transfers as-is.
 *
 * ASSUMPTION TO CONFIRM: the postal address below is Kuiken Technologies
 * LLC's registered address used for its other properties. Confirm it is
 * still correct before this goes live — a wrong address in a privacy
 * policy's contact section is itself a compliance problem.
 */

export const COMPANY = {
  /** Registered legal entity. */
  legalName: 'Kuiken Technologies LLC',
  /** Public-facing brand/trade name for this site. */
  tradeName: 'Thornless Data Management',
  /** Contact email shown across legal pages, footer, and forms. */
  email: 'adam@kuiken.tech',
  /** Governing-law / venue state for the Terms of Service. */
  state: 'Illinois',
  /** Physical mailing address — required in the Privacy Policy contact section. */
  addressLines: ['1220 Forest Ave', 'Oak Park, IL 60302'],
  /** Production domain, used for canonical references in legal copy. */
  domain: 'thornless.tech',
} as const;
